/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Agent_1_OverlineInputs */

const en_mk_agent_1_overline = /** @type {(inputs: Mk_Agent_1_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assign`)
};

const id_mk_agent_1_overline = /** @type {(inputs: Mk_Agent_1_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tugaskan`)
};

/**
* | output |
* | --- |
* | "Assign" |
*
* @param {Mk_Agent_1_OverlineInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_agent_1_overline = /** @type {((inputs?: Mk_Agent_1_OverlineInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Agent_1_OverlineInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_agent_1_overline(inputs)
	return en_mk_agent_1_overline(inputs)
});